/**
 * Muestras en el cart-drawer: el cliente elige en el panel.
 * - Total carrito (cart.total_price) ≥ umbral 1 (ej. 50€): hasta 1 muestra seleccionable.
 * - Total ≥ umbral 2 (ej. 100€): hasta 2 muestras seleccionables.
 * Al bajar de umbral se recorta la selección y se actualiza el carrito.
 *
 * SELECCIÓN DIFERIDA (Tier 2):
 * Tocar una tarjeta ya NO escribe en el carrito. Solo cambia la selección en
 * memoria y repinta el panel. El carrito se actualiza una sola vez, al pulsar
 * "Done", reutilizando syncDesiredSamplesToCart() sin modificar: toda la lógica
 * de umbrales, muestras vinculadas de España y reconciliación sigue siendo la
 * misma. Cerrar con la X, "Skip" o el fondo descarta los cambios pendientes.
 */
(function () {
  'use strict';

  function isSamplesSpain() {
    return !!(window.theme && window.theme.isSamplesSpain);
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  }

  function isSampleLine(item) {
    var p = item && item.properties;
    return p && (p.sample === true || p.sample === 'true');
  }

  function isPerfumeLine(item) {
    if (!item) return false;
    var p = item.properties || {};
    if (String(p._rockin_product_category || '').toLowerCase() === 'perfume') return true;
    if (String(item.product_type || '').toLowerCase() === 'perfume') return true;
    return false;
  }

  function cartHasPerfume(cart) {
    return paidLines(cart).some(isPerfumeLine);
  }

  /**
   * Los talleres (Workshop) no deben contar para desbloquear muestras
   * gratis ni para el aviso de "te faltan X€": es un servicio, no un
   * producto de perfumeria. Igual que isPerfumeLine, se mira
   * item.product_type (viene de cart.js con el Product Type de Shopify).
   */
  function isWorkshopLine(item) {
    if (!item) return false;
    return String(item.product_type || '').toLowerCase() === 'workshop';
  }

  /**
   * Subtotal que cuenta para los umbrales de muestras: todas las lineas
   * pagadas (no-muestra) EXCEPTO los talleres. Sustituye a cart.total_price
   * en toda la logica de umbrales para que un taller en el carrito no
   * dispare ni infle el desbloqueo de muestras gratis.
   */
  function eligibleSubtotal(cart) {
    return paidLines(cart)
      .filter(function (item) {
        return !isWorkshopLine(item);
      })
      .reduce(function (sum, item) {
        return sum + (item.line_price || 0);
      }, 0);
  }

  /**
   * El Try It First solo aplica a 50 ml y 100 ml: un 30 ml no arrastra
   * muestra. Se filtra aqui, sobre el carrito, y no en el formulario de
   * producto, porque asi da igual por donde se haya anadido el perfume
   * (ficha, anadido rapido o el carrito vacio) y la regla vive junto al
   * resto de reglas de muestras.
   */
  function variantQualifiesForLinkedSample(item) {
    var raw = String((item && item.variant_title) || '').toLowerCase();
    var parts = raw.split('/');
    for (var i = 0; i < parts.length; i++) {
      var size = parts[i].replace(/\s+/g, '');
      if (size === '50ml' || size === '100ml') return true;
    }
    return false;
  }

  function linkedSampleTargetsFromCart(cart) {
    var targets = [];
    if (!isSamplesSpain()) return targets;
    (cart.items || []).forEach(function (item) {
      if (isSampleLine(item)) return;
      if (!isPerfumeLine(item)) return;
      if (!variantQualifiesForLinkedSample(item)) return;
      var p = item && item.properties ? item.properties : {};
      var rawVid = p && (p._linked_sample_variant_id || p.linked_sample_variant_id);
      if (!rawVid) return;
      var variantId = Number(rawVid);
      if (isNaN(variantId)) return;

      var parentProductId = Number(p._linked_sample_parent_product_id || item.product_id);
      targets.push({
        variantId: variantId,
        parentKey: item.key,
        parentProductId: isNaN(parentProductId) ? '' : String(parentProductId),
      });
    });
    return targets;
  }

  function paidLines(cart) {
    return (cart.items || []).filter(function (i) {
      return !isSampleLine(i);
    });
  }

  function expandedSampleVariantIds(cart) {
    var out = [];
    (cart.items || []).forEach(function (it) {
      if (!isSampleLine(it)) return;
      var q = Math.max(0, parseInt(it.quantity, 10) || 0);
      for (var i = 0; i < q; i++) out.push(it.variant_id);
    });
    return out.sort(function (a, b) {
      return a - b;
    });
  }

  function idsEqualSorted(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (Number(a[i]) !== Number(b[i])) return false;
    }
    return true;
  }

  /** Cuántas muestras puede elegir el cliente según el total del carrito (céntimos). */
  function maxSamplesAllowed(totalCents, tier1, tier2) {
    if (totalCents < tier1) return 0;
    if (totalCents < tier2) return 1;
    return 2;
  }

  function readStoredIds(storageKey) {
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  /**
   * Formateo de importe con el patrón del tema. Se duplica aquí a propósito en
   * lugar de compartirlo con cart-incentive-message: este módulo ya tuvo un
   * conflicto de orden de carga y no conviene acoplarlo a otro script.
   */
  var MONEY_PLACEHOLDER = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}', 'g');

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '';
    var value = (cents || 0) / 100;
    function group(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    if (!format) return group(value, 2, ',', '.');
    return format.replace(MONEY_PLACEHOLDER, function (match, name) {
      switch (name) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        default: return group(value, 2, ',', '.');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('cart-samples-root');
    var panel = document.getElementById('samples-side-panel');
    if (!root || !panel) return;

    var samplesBlock = root.querySelector('.cart-samples-block');
    var drawerTitleEl = root.querySelector('.cart-samples-title');
    var cartPriceElement = document.querySelector('[data-cart-final]');

    var tier1 = parseInt(root.getAttribute('data-tier1-cents') || '5000', 10);
    var tier2 = parseInt(root.getAttribute('data-tier2-cents') || '10000', 10);
    var storageKey = root.getAttribute('data-storage-key') || 'selectedSampleVariantIds';

    /**
     * CAMPANA CREMA VAINILLA (temporal, 28 sep - 6 oct 2026, no USA).
     * Fecha y mercado ya se han evaluado en Liquid (cart-samples.liquid);
     * aqui solo se lee el resultado. Mientras `cvCampaignActive` es true,
     * esta muestra ocupa 1 plaza CON PRIORIDAD sobre el Try It First de
     * Espana: con 1 sola plaza disponible, se lleva esa; con 2, se lleva 1
     * y el Try It First (si aplica) se queda con la otra. Ver
     * lockedTargetsFor() mas abajo. Quitar este bloque, el atributo
     * data-cv-campaign-* en cart-samples.liquid y la rama 'campaign' en
     * syncDesiredSamplesToCart() cuando termine la campana.
     */
    var cvCampaignActive = root.getAttribute('data-cv-campaign-active') === 'true';
    var cvCampaignVariantId = parseInt(root.getAttribute('data-cv-campaign-variant-id') || '0', 10);

    /**
     * Excepción: si el carrito lleva el código RECEIVE3SAMPLES (3 muestras
     * de regalo, ver cart-promo-samples.liquid), la Crema Vainilla de la
     * campaña NO se añade — se pidió expresamente como excepción para no
     * duplicar regalos. El resto de la lógica de muestras (tramos, Try It
     * First) sigue igual, sin tocar por esto.
     */
    function cartHasReceive3SamplesPromo(cart) {
      return (cart.discount_codes || []).some(function (d) {
        return d && d.applicable !== false && String(d.code || '').toUpperCase() === 'RECEIVE3SAMPLES';
      });
    }

    /**
     * La Crema Vainilla aplica si: campaña activa (fecha + mercado != USA,
     * ya resuelto en Liquid), hay al menos una línea de pago real en el
     * carrito (nunca en un carrito vacío) y no hay RECEIVE3SAMPLES.
     */
    function campaignSampleApplies(cart) {
      return (
        cvCampaignActive &&
        !!cvCampaignVariantId &&
        paidLines(cart).length > 0 &&
        !cartHasReceive3SamplesPromo(cart)
      );
    }

    /**
     * Igual que maxSamplesAllowed(), pero con la Crema Vainilla SIN MÍNIMO
     * DE GASTO: si la campaña aplica y el tramo normal daría 0 plazas, se
     * garantiza igualmente 1 plaza (para esa muestra). Los tramos de 1 y 2
     * plazas no cambian: la campaña solo se lleva una de las que ya tocaban.
     */
    function effectiveAllowed(cart) {
      var base = maxSamplesAllowed(eligibleSubtotal(cart), tier1, tier2);
      if (campaignSampleApplies(cart) && base < 1) return 1;
      return base;
    }

    var changeBtn = document.getElementById('cart-samples-change');
    var closeBtn = document.getElementById('samples-close');
    var doneBtn = document.getElementById('samples-done');
    var skipBtn = document.getElementById('samples-skip');
    var sampleCards = document.querySelectorAll('.sample-card');
    var samplePreviewSlot = document.getElementById('sample-preview-slot');

    var allowanceLabelEl = panel.querySelector('[data-samples-allowance]');
    var countEl = panel.querySelector('[data-samples-count]');
    var slotsEl = panel.querySelector('[data-samples-slots]');
    var hintEl = panel.querySelector('[data-samples-hint]');

    var chooseTitleOne = root.getAttribute('data-i18n-choose-title-one') || '';
    var chooseTitleOther = root.getAttribute('data-i18n-choose-title-other') || '';
    var tplAllowance = panel.getAttribute('data-i18n-allowance') || 'Choose up to ||n||';
    var tplCount = panel.getAttribute('data-i18n-count') || '||s|| / ||m||';
    var tplUnlock = panel.getAttribute('data-i18n-unlock') || '';
    var txtSwap = panel.getAttribute('data-i18n-swap') || '';
    var txtAuto = panel.getAttribute('data-i18n-auto') || '';
    var txtDone = panel.getAttribute('data-i18n-done') || 'Done';

    function safeTextTemplate(raw, fallback) {
      var t = String(raw || '').trim();
      if (!t) return fallback;
      if (t.indexOf('translation missing') !== -1) return fallback;
      return t;
    }

    function pickPluralForm(maxSel) {
      return maxSel === 1 ? 'one' : 'other';
    }

    function applyChooseTitle(maxSel) {
      var form = pickPluralForm(maxSel);
      var fallback = 'Choose your complimentary samples';
      var title = form === 'one' ? chooseTitleOne : chooseTitleOther;
      title = safeTextTemplate(title, fallback);
      if (drawerTitleEl) drawerTitleEl.textContent = title;
    }

    var userSelectedVariantIds = new Set();
    var lockedVariantIds = new Set();
    var isSyncing = false;
    var debounceTimer = null;

    // Estado propio de la selección diferida
    var panelCart = null; // último carrito conocido, para no pedirlo en cada clic
    var selectionOnOpen = new Set(); // para poder descartar cambios al cancelar

    function startLoading() {
      isSyncing = true;
      root.classList.add('is-loading');
      panel.classList.add('is-loading');
    }

    function stopLoading() {
      isSyncing = false;
      root.classList.remove('is-loading');
      panel.classList.remove('is-loading');
    }

    function isPanelOpen() {
      return panel.classList.contains('opened');
    }

    function openPanel() {
      selectionOnOpen = new Set(userSelectedVariantIds);
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('opened');
      document.body.classList.add('samples-panel-open');
      updatePanelUI();
    }

    function closePanel() {
      panel.setAttribute('aria-hidden', 'true');
      panel.classList.remove('opened');
      document.body.classList.remove('samples-panel-open');
    }

    /** Cierra descartando lo que el cliente haya tocado sin confirmar. */
    function cancelPanel() {
      userSelectedVariantIds = new Set(selectionOnOpen);
      renderPanel(panelCart);
      closePanel();
    }

    /** Única escritura al carrito: confirma la selección pendiente. */
    function commitPanel() {
      if (isSyncing) return;
      window
        .fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(async function (cart) {
          panelCart = cart;
          await syncDesiredSamplesToCart(cart);
          updateSelectedSampleUI();
          selectionOnOpen = new Set(userSelectedVariantIds);
          closePanel();
        })
        .catch(function () {
          closePanel();
        });
    }

    /**
     * Máximo de sample-card seleccionables en el panel: solo lo fijan los umbrales (50€ → 1, 100€ → 2).
     * No usar samples_max_select del tema aquí: en tiendas con valor antiguo "1" bloqueaba la 2ª muestra.
     */
    function panelMaxSelect(cart) {
      return effectiveAllowed(cart);
    }

    /**
     * Muestras automáticas que caben de verdad. Ocupan plaza antes que las
     * elegidas y el total nunca pasa de `allowed`.
     *
     * Orden de prioridad por plaza:
     *   1. Campaña Crema Vainilla (si está activa para este carrito/fecha):
     *      se lleva 1 plaza siempre que allowed > 0, por delante de todo lo
     *      demás. Con 1 sola plaza disponible es la ÚNICA automática: el
     *      Try It First no entra ese caso.
     *   2. Try It First (España): con las plazas que sobren, igual que antes
     *      (con 1 perfume queda 1 plaza elegible, con 2 no queda ninguna, y
     *      con 3 solo entran las de los 2 primeros perfumes del carrito).
     */
    function lockedTargetsFor(cart, allowed) {
      var targets = [];
      var remaining = allowed;

      if (campaignSampleApplies(cart) && remaining > 0) {
        targets.push({ variantId: cvCampaignVariantId, source: 'campaign' });
        remaining -= 1;
      }

      // cart.items llega del mas reciente al mas antiguo (verificado en esta
      // tienda), asi que se invierte para que, cuando sobran perfumes, las
      // plazas se las queden los dos PRIMEROS que anadio la clienta.
      var linked = linkedSampleTargetsFromCart(cart).slice().reverse().slice(0, remaining);
      return targets.concat(linked);
    }

    function trimUserSelectionToAllowed(allowed) {
      var arr = Array.from(userSelectedVariantIds);
      if (arr.length <= allowed) return;
      userSelectedVariantIds = new Set(arr.slice(0, allowed));
      updateSelectedSampleUI();
    }

    function totalSelectedCount() {
      return lockedVariantIds.size + userSelectedVariantIds.size;
    }

    function combinedSelectedVariantIds() {
      var combined = new Set();
      lockedVariantIds.forEach(function (id) {
        combined.add(String(id));
      });
      userSelectedVariantIds.forEach(function (id) {
        combined.add(String(id));
      });
      return combined;
    }

    function userMaxSelectable(allowed) {
      // Si hay un sample vinculado y allowed=1, no debe permitir elegir otro sample.
      // Si allowed=2, permite 1 adicional (pero si el usuario ya tiene 2 seleccionados, no se recorta: se permite acumular).
      var lockedSlots = Math.min(lockedVariantIds.size, allowed);
      return Math.max(0, allowed - lockedSlots);
    }

    /** Miniaturas en el drawer + persistencia: refleja lo YA confirmado. */
    function updateSelectedSampleUI() {
      var selectedData = [];
      var combined = combinedSelectedVariantIds();
      sampleCards.forEach(function (card) {
        if (combined.has(card.getAttribute('data-variant-id'))) {
          selectedData.push({
            title: card.getAttribute('data-product-title') || '',
            imgSrc: card.getAttribute('data-img') || '',
          });
        }
      });

      if (!samplePreviewSlot) return;

      if (selectedData.length === 0) {
        samplePreviewSlot.innerHTML = '<div class="no-samples"></div>';
        if (userSelectedVariantIds.size === 0) localStorage.removeItem(storageKey);
        return;
      }

      samplePreviewSlot.innerHTML = selectedData
        .map(function (data) {
          return (
            '<div class="selected-sample-item">' +
            '<img src="' +
            data.imgSrc +
            '" alt="' +
            (data.title || '').replace(/"/g, '&quot;') +
            '" style="max-width:50px;height:auto;">' +
            '</div>'
          );
        })
        .join('');

      localStorage.setItem(storageKey, JSON.stringify(Array.from(userSelectedVariantIds)));
    }

    /** Repinta el panel a partir de la selección pendiente. No toca el carrito. */
    function renderPanel(cart) {
      if (!cart) return;
      var maxSel = panelMaxSelect(cart);
      var userMax = userMaxSelectable(maxSel);
      var userCount = userSelectedVariantIds.size;
      var limitReached = userCount >= userMax && userMax > 0;
      var combined = combinedSelectedVariantIds();

      applyChooseTitle(maxSel);

      sampleCards.forEach(function (card) {
        var vid = card.getAttribute('data-variant-id');
        var isLocked = lockedVariantIds.has(vid);
        var isSelected = combined.has(vid);
        card.classList.toggle('is-selected', isSelected);
        card.classList.toggle('is-locked', isLocked);
        card.classList.toggle('is-disabled-by-limit', limitReached && !isSelected);
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      var shown = totalSelectedCount();
      var capacity = maxSel;

      if (allowanceLabelEl) {
        allowanceLabelEl.textContent = tplAllowance.replace('||n||', String(capacity));
      }
      if (countEl) {
        countEl.textContent = tplCount
          .replace('||s||', String(shown))
          .replace('||m||', String(capacity));
      }
      if (slotsEl) {
        var html = '';
        for (var i = 0; i < capacity; i++) {
          html += '<span class="samples-slot' + (i < shown ? ' is-on' : '') + '"></span>';
        }
        slotsEl.innerHTML = html;
      }

      if (hintEl) {
        var total = eligibleSubtotal(cart);
        var hint = '';
        if (lockedVariantIds.size > 0 && txtAuto) {
          // Spain: explaining the auto-attached sample outranks the other
          // hints — otherwise a card looks selected for no visible reason.
          hint = txtAuto;
        } else if (limitReached && txtSwap) {
          hint = txtSwap;
        } else if (capacity < 2 && total < tier2 && tplUnlock) {
          hint = tplUnlock.replace('||amount||', formatMoney(tier2 - total));
        }
        hintEl.textContent = hint;
        hintEl.hidden = hint === '';
      }

      if (doneBtn) {
        doneBtn.textContent =
          txtDone +
          ' · ' +
          tplCount.replace('||s||', String(shown)).replace('||m||', String(capacity));
      }
    }

    function updatePanelUI(cart) {
      if (cart) {
        panelCart = cart;
        lockedVariantIds = new Set(
          lockedTargetsFor(cart, panelMaxSelect(cart)).map(function (t) {
            return String(t.variantId);
          })
        );
        renderPanel(cart);
        return;
      }
      window
        .fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (fresh) {
          panelCart = fresh;
          lockedVariantIds = new Set(
            lockedTargetsFor(fresh, panelMaxSelect(fresh)).map(function (t) {
              return String(t.variantId);
            })
          );
          renderPanel(fresh);
        })
        .catch(function () {});
    }

    function loadSelectedSample() {
      var storedIds = readStoredIds(storageKey);
      if (storedIds.length) {
        userSelectedVariantIds = new Set(storedIds);
        updateSelectedSampleUI();
      }
    }

    function setVisibilityFromCart(cart) {
      if (!samplesBlock) return;
      var total = eligibleSubtotal(cart);
      var paid = paidLines(cart).length;

      // Crema Vainilla es SIN MÍNIMO DE GASTO: el módulo se muestra aunque
      // el carrito no llegue al umbral 1, siempre que la campaña aplique
      // (fecha + mercado + sin RECEIVE3SAMPLES) y haya algo pagado.
      var showForTier = paid > 0 && total >= tier1;
      var showForCampaign = paid > 0 && campaignSampleApplies(cart);
      if (showForTier || showForCampaign) {
        samplesBlock.style.display = 'block';
      } else {
        samplesBlock.style.display = 'none';
      }

      /**
       * CAMPANA CREMA VAINILLA: cuando todas las plazas de muestra ya están
       * ocupadas por automáticas (campaña y/o Try It First de España), no
       * queda nada que elegir. Se oculta el título "Choose your
       * complimentary sample(s)" y el enlace "Select" — las miniaturas de
       * lo ya incluido se siguen viendo igual, vía updateSelectedSampleUI().
       */
      var allowed = effectiveAllowed(cart);
      var lockedCount = lockedTargetsFor(cart, allowed).length;
      var userMax = Math.max(0, allowed - Math.min(lockedCount, allowed));
      var hasChoice = userMax > 0;
      if (drawerTitleEl) drawerTitleEl.style.display = hasChoice ? '' : 'none';
      if (changeBtn) changeBtn.style.display = hasChoice ? '' : 'none';
    }

    /**
     * Deja el carrito alineado con la selección actual (como mucho `allowed` líneas de muestra).
     * SIN CAMBIOS respecto a la versión anterior: solo cambia quién la invoca.
     */
    async function syncDesiredSamplesToCart(cart) {
      if (isSyncing) return;

      var allowed = effectiveAllowed(cart);
      trimUserSelectionToAllowed(allowed);

      if (allowed === 0) {
        var samplesZero = (cart.items || []).filter(isSampleLine);
        if (samplesZero.length === 0) {
          setVisibilityFromCart(cart);
          return;
        }
        lockedVariantIds = new Set();
        startLoading();
        try {
          // Una sola llamada para vaciar todas las muestras (antes: una
          // petición /cart/change.js por muestra, en serie).
          var updatesZero = {};
          samplesZero.forEach(function (s) {
            updatesZero[s.key] = 0;
          });
          await window.fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updatesZero }),
          });
          var u0 = await window.fetch('/cart.js').then(function (r) {
            return r.json();
          });
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', { detail: { cart: u0 }, bubbles: true })
          );
          refreshCartUI();
        } catch (e) {
          console.error('Muestras: error al vaciar muestras', e);
        } finally {
          stopLoading();
        }
        return;
      }

      var linkedTargets = lockedTargetsFor(cart, allowed);
      lockedVariantIds = new Set(
        linkedTargets.map(function (t) {
          return String(t.variantId);
        })
      );

      // Lo elegido solo llena las plazas que dejan libres las automaticas, y
      // nunca repite una muestra que ya venga incluida. Antes se recortaba a
      // `allowed` ignorando las automaticas, asi que 1 perfume + 2 elegidas
      // acababan metiendo 3 muestras en el carrito.
      var remaining = Math.max(0, allowed - linkedTargets.length);
      var desired = Array.from(userSelectedVariantIds)
        .filter(function (id) {
          return !lockedVariantIds.has(String(id));
        })
        .slice(0, remaining)
        .map(function (id) {
          return Number(id);
        })
        .filter(function (id) {
          return !isNaN(id);
        });

      var targetItems = [];
      for (var lt = 0; lt < linkedTargets.length; lt++) {
        var lockedTarget = linkedTargets[lt];
        var lockedProps = { sample: 'true' };
        if (lockedTarget.source === 'campaign') {
          lockedProps.sample_source = 'campaign_crema_vainilla';
        } else {
          lockedProps.sample_source = 'linked_product';
          lockedProps.sample_parent_key = lockedTarget.parentKey;
          lockedProps.sample_parent_product_id = lockedTarget.parentProductId;
        }
        targetItems.push({ id: lockedTarget.variantId, properties: lockedProps });
      }
      for (var du = 0; du < desired.length; du++) {
        targetItems.push({
          id: desired[du],
          properties: { sample: 'true' },
        });
      }

      var curSorted = expandedSampleVariantIds(cart);
      var targetSorted = targetItems
        .map(function (x) {
          return x.id;
        })
        .slice()
        .sort(function (a, b) {
          return a - b;
        });

      if (idsEqualSorted(curSorted, targetSorted)) {
        setVisibilityFromCart(cart);
        return;
      }

      startLoading();
      try {
        var fresh = await window.fetch('/cart.js').then(function (r) {
          return r.json();
        });
        var existingSamples = (fresh.items || []).filter(isSampleLine);

        /**
         * RECONCILIACIÓN POR DIFERENCIA (antes: se borraban TODAS las
         * muestras y se volvían a añadir todas, una por una, en serie —
         * de ahí el "añade y quita" visible y la lentitud: con Crema
         * Vainilla presente casi siempre, era la muestra más común que
         * parpadeaba sin necesidad). Ahora solo se toca lo que realmente
         * cambia, y cada tanda (borrados / altas) va en UNA sola llamada
         * a la API del carrito en vez de una por línea.
         */
        var targetVariantIds = targetItems.map(function (t) {
          return String(t.id);
        });
        var existingByVariant = {};
        existingSamples.forEach(function (s) {
          existingByVariant[String(s.variant_id)] = s;
        });

        var toRemove = existingSamples.filter(function (s) {
          return targetVariantIds.indexOf(String(s.variant_id)) === -1;
        });
        var toAdd = targetItems.filter(function (t) {
          return !existingByVariant[String(t.id)];
        });

        if (toRemove.length > 0) {
          var updates = {};
          toRemove.forEach(function (s) {
            updates[s.key] = 0;
          });
          await window.fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates }),
          });
        }

        if (toAdd.length > 0) {
          await window.fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: toAdd.map(function (t) {
                return { id: t.id, quantity: 1, properties: t.properties };
              }),
            }),
          });
        }

        var updated = await window.fetch('/cart.js').then(function (r) {
          return r.json();
        });
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', { detail: { cart: updated }, bubbles: true })
        );
        refreshCartUI();
        setVisibilityFromCart(updated);
      } catch (err) {
        console.error('Muestras: error al sincronizar', err);
      } finally {
        stopLoading();
      }
    }

    function scheduleEnforce(cart) {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        debounceTimer = null;

        function apply(c) {
          setVisibilityFromCart(c);
          trimUserSelectionToAllowed(effectiveAllowed(c));
          // Con el panel abierto solo repintamos: confirmar la selección
          // pendiente es cosa del botón "Done", no de un cambio de carrito.
          if (isPanelOpen()) {
            updatePanelUI(c);
            return;
          }
          return syncDesiredSamplesToCart(c);
        }

        if (cart) {
          apply(cart);
        } else {
          window
            .fetch('/cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(apply)
            .catch(function () {});
        }
      }, 280);
    }

    document.addEventListener('theme:cart:change', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      scheduleEnforce(cart);
    });

    if (cartPriceElement) {
      var observer = new MutationObserver(function () {
        scheduleEnforce(null);
      });
      observer.observe(cartPriceElement, { characterData: true, subtree: true, childList: true });
    }

    loadSelectedSample();

    window
      .fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        panelCart = cart;
        setVisibilityFromCart(cart);
        trimUserSelectionToAllowed(effectiveAllowed(cart));
        syncDesiredSamplesToCart(cart);
      })
      .catch(function () {});

    changeBtn &&
      changeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window
          .fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            panelCart = cart;
            setVisibilityFromCart(cart);
            if (samplesBlock && samplesBlock.style.display === 'block') {
              openPanel();
            }
          })
          .catch(function () {});
      });

    closeBtn &&
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        cancelPanel();
      });

    skipBtn &&
      skipBtn.addEventListener('click', function (e) {
        e.preventDefault();
        cancelPanel();
      });

    doneBtn &&
      doneBtn.addEventListener('click', function (e) {
        e.preventDefault();
        commitPanel();
      });

    panel.addEventListener('click', function (e) {
      if (e.target === panel) cancelPanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isPanelOpen()) cancelPanel();
    });

    /** Clic en tarjeta: selección en memoria, cero escrituras al carrito. */
    function toggleCard(card) {
      if (isSyncing) return;
      var cart = panelCart;
      if (!cart) return;

      var userMax = userMaxSelectable(panelMaxSelect(cart));
      var vid = card.getAttribute('data-variant-id');
      if (lockedVariantIds.has(vid)) return;

      if (userSelectedVariantIds.has(vid)) {
        userSelectedVariantIds.delete(vid);
      } else {
        if (userSelectedVariantIds.size >= userMax) {
          card.classList.add('limit-reached');
          setTimeout(function () {
            card.classList.remove('limit-reached');
          }, 600);
          return;
        }
        userSelectedVariantIds.add(vid);
      }

      renderPanel(cart);
    }

    sampleCards.forEach(function (card) {
      card.addEventListener('click', function () {
        toggleCard(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggleCard(card);
        }
      });
    });
  });
})();
